import styled from "styled-components";

export const MusicHallListContainerStyled = styled.div`
  .btn_create {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
  .title {
    padding: 0 20px;
    color: ${({ theme }) => theme.COLORS.BLACK_2};
    font-size: ${({ theme }) => theme.FONT.SIZE.S22};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_BOLD};
  }
  .filter_layout {
    margin-bottom: 22px;
  }
  /* วันสำรองมีได้ 2 วัน เว้นระยะให้เห็นว่าเป็นคนละชุดกัน */
  .date_block_group {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
  }
`;
